/**
 * Created by agengmaulana on 5/3/17.
 */
import React from 'react'
import styles from './../../assets/css/comment.css'


export default class Comment_Count extends React.Component {
    constructor(props) {
        super(props);

    }

    render(){
        return(
            <span className={styles.cmt_count_komen} >{this.props.countComment} komentar</span>
        )
    }
}


// WEBPACK FOOTER //
// ./static/src/component/comment_count/comment_count.js